import React, { useEffect, useState } from "react";
import { Table, Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaTimes } from "react-icons/fa";

const BASE_URL = process.env.REACT_APP_BASE_URL; // Your API base url

const MessageTable = () => {
  const [messages, setMessages] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  // Fetch Data
  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/superadmin/getEnquiries`) // example endpoint
      .then((res) => setMessages(res.data))
      .catch((err) => console.error("Error fetching messages:", err));
  }, []);

  // Filter data by selected date (format: yyyy-mm-dd)
  const filteredData = selectedDate
    ? messages.filter((msg) => msg.created_at?.startsWith(selectedDate))
    : messages;

  // Generate PDF
  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.text("Messages Report", 14, 15);

    autoTable(doc, {
      head: [["ID", "Name", "Email", "Mobile", "Message", "Created At"]],
      body: filteredData.map((item, idx) => [
        idx + 1,
        item.name,
        item.email,
        item.mobile,
        item.message,
        new Date(item.created_at).toLocaleString(),
      ]),
      startY: 25,
    });

    const fileName = selectedDate
      ? `Messages_${selectedDate}.pdf`
      : "Messages_All.pdf";
    doc.save(fileName);
  };

  return (
    <Container fluid className="mt-4">
      <Row className="align-items-center mb-3">
        <Col md={3}>
          <h2 className="global-heading">Messages</h2>
        </Col>
        <Col md={4}>
          <InputGroup>
            <Form.Control
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
            />
            {selectedDate && (
                <Button
                variant="outline-danger"
                onClick={() => setSelectedDate("")}
                title="Clear Filter"
                >
                <FaTimes />
                </Button>
            )}
            </InputGroup>
        </Col>
        <Col md={3}>
          <Button className="btn-custom" onClick={downloadPDF}>
            Download PDF
          </Button>
        </Col>
      </Row>

      <div className="AdminTable-root table-responsive">
        <Table striped hover responsive className="mb-0">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile Number</th>
              <th>Message</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.mobile}</td>
                  <td>{item.message}</td>
                  <td>{new Date(item.created_at).toLocaleString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center text-muted">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </Container>
  );
};

export default MessageTable;
